import { ViewContainer } from "components";
import { useLocation } from "react-router";
import { useScreen } from "utils";
import { YourCampaignsScreenDefinition } from "../CampaignsWizard/YourCampaigns.definition";
import { CampaignsTable } from "./CampaignsTable";

const YourCampaigns = () => {
  useScreen(YourCampaignsScreenDefinition);
  const location = useLocation();
  let key = "intent-models";

  // swapping the key out forces a full component remount resetting
  // all the state without making the page have a hard reload
  if (location.search === "?fresh") {
    key = location.key;
  }

  return (
    <ViewContainer key={key}>
      <CampaignsTable />
    </ViewContainer>
  );
};

export { YourCampaigns };
